var _defs, _circle, _circle2, _line, _line2, _line3, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTranslucent(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Translucency",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n      fill: none;\n      stroke: currentColor;\n      stroke-width: 8px;\n      }\n    "))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 60,
    cy: 36,
    r: 32
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 36,
    cy: 60,
    r: 32
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 67.02,
    y1: 6.2,
    x2: 30.07,
    y2: 43.15
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 91.83,
    y1: 26.85,
    x2: 52.1,
    y2: 66.58
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 82.83,
    y1: 13.11,
    x2: 37.67,
    y2: 58.27
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m62.11,69.96c-19.88,0-36-16.12-36-36,0-3.07.39-6.05,1.11-8.89C11.64,29.03.11,43.14.11,59.96c0,19.88,16.12,36,36,36,16.81,0,30.93-11.53,34.89-27.11-2.84.72-5.82,1.11-8.89,1.11Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTranslucent);
export default __webpack_public_path__ + "static/media/translucent.f1e5c1a041b9811ae498737dbbc8fe57.svg";
export { ForwardRef as ReactComponent };